import { call, all, put, select } from 'redux-saga/effects';
import { actions as actionsInitPage } from '@/reducers/initPage';
import { handlingCodes } from '@/constants/constants';
import { handleSagaError } from '@/sagas/index';
// 

const initPageStore = (state) => state.initPage;

export function* initPage(args) {
  const { dependencies } = args.payload;
  const dependenciesFilter=dependencies.filter(x=>x!=='no')
  try {
    let importantError = false;
    let handlingCode = handlingCodes.NOTHINGTODO;
    const location = initPageStore.location;
    //yield put(actionsInitPage.setInitPageBegins(location));

    if (Array.isArray(dependenciesFilter) && dependenciesFilter.length > 0) {
      for (let i = 0; i < dependenciesFilter.length; i++) {
        const saga = dependenciesFilter[i];
        const { file, fn } = saga.data;
        const importedFile = yield import(`./${file}`);
        saga.function = importedFile[fn];
        saga.args = saga.args || {};
      }
    }
    const dependenciesPriority = dependenciesFilter.filter(
      (sagaFilter) => sagaFilter.priority === true
    );
    const dependenciesNoPriority = dependenciesFilter.filter(
      (sagaFilter) => sagaFilter.priority !== true
    );

    const responses = yield all(
      dependenciesPriority.map((saga) => call(saga.function, saga.args))
    );
    responses.map((response, i) => {
      const handlingCodeTemp =
        dependenciesPriority[i]?.handlingCode || handlingCodes.FATAL;
      if (handlingCodeTemp < 0 && response?.status === 'ko') {
        importantError = true;
        if (handlingCodeTemp < 0) {
          if (
            handlingCodeTemp > handlingCode ||
            handlingCode === handlingCodes.NOTHINGTODO
          ) {
            handlingCode = handlingCodeTemp;
          }
        }
      }
    });
    if (importantError) {
      yield put(actionsInitPage.setInitPageFailure(handlingCode));
    } else {
      yield put(actionsInitPage.setInitPageSuccess());
    }

    // Se lanzan las funciones no prioritarias siempre que una prioritaria no falle
    if (!importantError) {
      yield all(
        dependenciesNoPriority.map((saga) => call(saga.function, saga.args))
      );
    }
  } catch (error) {
    const reducerFailureAction = actionsInitPage.setInitPageFailure(
      handlingCodes.FATAL
    );
    yield handleSagaError(
      'initPage',
      error,
      handlingCodes.FATAL,
      reducerFailureAction
    );
  }
}
